// src/utils/validation.js

import { parseLocalDate } from "./dateUtils"; // Import the helper function

export const validateChallengeFields = (formData) => {
  const errors = {};

  // Existing validations...
  if (!formData.title.trim()) {
    errors.title = "Title is required.";
  }

  if (!formData.description.trim()) {
    errors.description = "Description is required.";
  }

  if (!formData.prize.trim()) {
    errors.prize = "Prize details are required.";
  }

  // Date Validations
  const { startDate, endDate, fulfillmentDate } = formData;

  if (!startDate) {
    errors.startDate = "Start date is required.";
  }

  if (!endDate) {
    errors.endDate = "End date is required.";
  }

  if (!fulfillmentDate) {
    errors.fulfillmentDate = "Fulfillment date is required.";
  }

  // Only proceed with date comparisons if all dates are present
  if (startDate && endDate && fulfillmentDate) {
    const start = parseLocalDate(startDate);
    const end = parseLocalDate(endDate);
    const fulfillment = parseLocalDate(fulfillmentDate);

    if (start >= end) {
      errors.endDate = "End date must be after the start date.";
    }

    if (end >= fulfillment) {
      errors.fulfillmentDate = "Fulfillment date must be after the end date.";
    }
  }

  // Ensure dates are not in the past (today is allowed)
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Normalize to local midnight

  if (startDate) {
    const start = parseLocalDate(startDate);
    if (start < today) {
      errors.startDate = "Start date cannot be in the past.";
    }
  }

  if (endDate) {
    const end = parseLocalDate(endDate);
    if (end < today) {
      errors.endDate = "End date cannot be in the past.";
    }
  }

  if (fulfillmentDate) {
    const fulfillment = parseLocalDate(fulfillmentDate);
    if (fulfillment < today) {
      errors.fulfillmentDate = "Fulfillment date cannot be in the past.";
    }
  }

  // Submission Fee Validation (optional)
  if (formData.chargeSubmissionFee) {
    const fee = parseFloat(formData.submissionFee);
    if (isNaN(fee) || fee < 5) {
      errors.submissionFee = "Submission fee must be at least $5.";
    }
  }

  return errors;
};

export const getSnackbarErrorMessage = (fieldErrors) => {
  const errorMessages = Object.values(fieldErrors);
  return errorMessages.length > 0
    ? errorMessages.join(", ")
    : "An error occurred.";
};
